import { Router } from 'aurelia-router';
import Cookies from 'js-cookie';
import { Customer } from '../../models/customer';
import { Business } from '../../models/business';
import { State } from '../../services/global-state';
import { PayrazrService } from '../../services/payrazr';
import { I18N } from 'aurelia-i18n';
import { mock, instance, verify, when } from 'ts-mockito';
import { Login } from './login';
import { EventAggregator } from 'aurelia-event-aggregator';
import { HpfCarouselService } from '../../services/hpf-carousel.service';
import { PostLoginRouteManager } from '../../helpers/post-login-route-manager';
import { DialogService } from 'aurelia-dialog';

describe('NewPortalWeb', () => {
	describe('pages', () => {
		describe('login-register', () => {
			describe('login', () => {
				let component: Login;
				let stubState: State;
				const mockCustomer: Customer = mock(Customer);
				const mockBusiness: Business = mock(Business);
				const mockRouter: Router = mock(Router);
				const mockState: State = mock(State);
				const mockPayrazrService: PayrazrService = mock(PayrazrService);
				const mockHpfCarouselService: HpfCarouselService = mock(HpfCarouselService);
				const mockI18N: I18N = mock(I18N);
				const mockPostLoginRouteManager = mock(PostLoginRouteManager);
				const mockEventAggregator: EventAggregator = mock(EventAggregator);
				const mockDialogService: DialogService = mock(DialogService);
				beforeEach(() => {
					stubState = new State(
						instance(mockI18N),
						instance(mockEventAggregator)
					);

					const i18next = {
						t: (a, b) => a
					};
					when(mockI18N.i18next).thenReturn(i18next);
					stubState.business = instance(mockBusiness);
					spyOn(i18next, 't').and.returnValue('localized');

					component = new Login(
						instance(mockRouter),
						instance(mockPayrazrService),
						instance(mockHpfCarouselService),
						stubState,
						instance(mockI18N),
						instance(mockPostLoginRouteManager),
						instance(mockEventAggregator),
						instance(mockDialogService)
					);
				});
				it('should initialize Login component', () => {
					expect(component).toBeTruthy();
				});

				describe('startRegister', () => {
					it('should navigate route to register', () => {
						stubState.business = {
							portalSettings: {
								businessSettings: {
									hideTerms: false,
									enablePreferredLanguageAcknowledgement: true
								}
							}
						};

						component.registerTermsAgreed = true;

						let tcElement = document.createElement('input') as HTMLInputElement;
						tcElement.setAttribute('id', 'signUp-t-c-agreed');
						tcElement.setAttribute('type', 'checkbox');
						tcElement.setAttribute('checked', 'true');

						spyOn(document, 'getElementById').and.returnValues(tcElement);

						component.startRegister();
						verify(mockRouter.navigateToRoute('register')).called();
					});
				});

				describe('startEzpay', () => {
					it('should navigate route to ezpay on success', async () => {
						stubState.business = {
							portalSettings: {
								businessSettings: {
									hideTerms: false,
									enablePreferredLanguageAcknowledgement: true
								}
							}
						};

						component.ezpayTermsAgreed = true;
						when(mockState.business).thenReturn({
							sessionId: ''
						});

						let tcElement = document.createElement('input') as HTMLInputElement;
						tcElement.setAttribute('id', 'ezpay-t-c-agreed');
						tcElement.setAttribute('type', 'checkbox');
						tcElement.setAttribute('checked', 'true');

						spyOn(document, 'getElementById').and.returnValues(tcElement);

						let response = {
							isSuccessful: true,
							entity: '12345'
						};
						when(mockPayrazrService.startEzpay()).thenReturn(Promise.resolve(response));
						await component.startEzpay();
						verify(mockRouter.navigateToRoute('ezpay')).called();
					});
					it('should alert error on failure', async () => {
						stubState.business = {
							portalSettings: {
								businessSettings: {
									hideTerms: false,
									enablePreferredLanguageAcknowledgement: true
								}
							}
						};

						component.ezpayTermsAgreed = true;

						let tcElement = document.createElement('input') as HTMLInputElement;
						tcElement.setAttribute('id', 'ezpay-t-c-agreed');
						tcElement.setAttribute('type', 'checkbox');
						tcElement.setAttribute('checked', 'true');

						spyOn(document, 'getElementById').and.returnValues(tcElement);

						spyOn(window, 'alert');
						let response = {
							isSuccessful: false
						};
						when(mockPayrazrService.startEzpay()).thenReturn(Promise.resolve(response));
						await component.startEzpay();
						expect(window.alert).toHaveBeenCalledWith('localized');
					});
				});

				describe('handleRemember', () => {
					it('should set cookie value when rememeber me is checked', () => {
						spyOn(Cookies, 'set');
						component.rememberMe = true;
						component.model.username = 'JaneDoe';
						component.handleRemember();
						expect(Cookies.set).toHaveBeenCalledWith('RememberMe', 'JaneDoe', { expires: 60, path: '' });
					});
					it('should remove when rememeber me is unchecked', () => {
						spyOn(Cookies, 'remove');
						component.rememberMe = null;
						component.handleRemember();
						expect(Cookies.remove).toHaveBeenCalledWith('RememberMe', { path: '' });
					});
				});
				describe('fetchRememberMe', () => {
					it('should get username value from cookie', () => {
						spyOn(Cookies, 'get').and.returnValue('JaneDoe');
						component.fetchRememberMe();
						expect(Cookies.get).toHaveBeenCalledWith('RememberMe');
						expect(component.model.username).toEqual('JaneDoe');
						expect(component.rememberMe).toEqual(true);
					});
				});
				describe('attached', () => {
					it('must call update session', () => {
						spyOn(component, 'getCarousel').and.stub();
						spyOn(component, 'updateSession').and.stub();
						component.attached();
						expect(component.getCarousel).toHaveBeenCalled();
						expect(component.updateSession).toHaveBeenCalled();
					});
				});
				describe('updateSession', () => {
					it('should call resetSession from payrazr service', async () => {
						when(mockPayrazrService.resetSession()).thenResolve({
							response: {
								isSuccessful: true
							}
						});
						component.updateSession();
						verify(mockPayrazrService.resetSession()).called();
					});
				});
			});
		});
	});
});
